import { useAuthUserConfig, userTermsVersionSelector } from '@/hooks/use-auth-user-config';
import { useJurisdictionStore } from '@/hooks/use-jurisdiction';

import { PRODUCT_TO_TERMS_VERTICALS } from '../utils/terms-and-conditions-utils';

/**
 * Custom hook to get user's terms and conditions acceptance status for the current product
 * @returns Object containing the T&C acceptance status
 */
export const useHasUserAcceptedProductTerms = () => {
    const product = useJurisdictionStore(state => state.product);

    const { data: userTermsVersions } = useAuthUserConfig({
        select: userTermsVersionSelector,
    });

    const activeProductTermsVerticals = PRODUCT_TO_TERMS_VERTICALS[product] || [];

    const currentProductTncs = activeProductTermsVerticals.map(vertical =>
        userTermsVersions?.find(term => term.vertical === vertical)
    );

    return {
        isAccepted: currentProductTncs.every(tnc => tnc?.accepted_and_updated ?? false),
    };
};
